// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { createTrailer, deleteTrailer, getDetailTrailer, getListTrailer, updateTrailer } from './trailerThunk';

export interface ITrailerState {
  isRefreshTrailerList: boolean;
}

export const initialState: ITrailerState = {
  isRefreshTrailerList: false,
};

const trailerSlice = createSlice({
  name: 'trailer',
  initialState,
  reducers: {
    setRefreshTrailerList(state, action) {
      state.isRefreshTrailerList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list trailer
    builder
      .addCase(getListTrailer.pending, (_state) => {})
      .addCase(getListTrailer.fulfilled, (_state) => {})
      .addCase(getListTrailer.rejected, (_state) => {});

    // GET: Get detail trailer
    builder
      .addCase(getDetailTrailer.pending, (_state) => {})
      .addCase(getDetailTrailer.fulfilled, (_state) => {})
      .addCase(getDetailTrailer.rejected, (_state) => {});

    // POST: Create trailer
    builder
      .addCase(createTrailer.pending, (_state) => {})
      .addCase(createTrailer.fulfilled, (state) => {
        state.isRefreshTrailerList = true;
      })
      .addCase(createTrailer.rejected, (_state) => {});

    // PUT: Update trailer
    builder
      .addCase(updateTrailer.pending, (_state) => {})
      .addCase(updateTrailer.fulfilled, (state) => {
        state.isRefreshTrailerList = true;
      })
      .addCase(updateTrailer.rejected, (_state) => {});

    // DELETE: Delete trailer
    builder
      .addCase(deleteTrailer.pending, (_state) => {})
      .addCase(deleteTrailer.fulfilled, (state) => {
        state.isRefreshTrailerList = true;
      })
      .addCase(deleteTrailer.rejected, (_state) => {});
  },
});

// Action
export const trailerActions = trailerSlice.actions;

// Selectors
// Reducer
const trailerReducer = trailerSlice.reducer;
export default trailerReducer;
